module.exports = __webpack_public_path__ + "img/0-9-talpa.abc30499.gif";